import styled from 'styled-components';
import { Link } from 'react-scroll';

export const Button = styled(Link)`
display: flex;
border-radius: 50px;
background: ${({ primary }) => (primary ? '#1C75BC' : '#010606')};
white-space: nowrap;
padding: ${({big}) => (big ? '14px 48px' : '12px 30px')};
color: ${({dark}) => (dark ? '#010606' : '#f2f2f2')};
font-size: ${({fontBig}) => (fontBig ? '20px' : '16px')};
outline: none;
border: none;
cursor: pointer:
justify-content: center;
align-items: center;
transition: all 0.2s ease-in-out;

&:hover {
    transition: all 0.2s ease-in-out;
    background: ${({primary}) => (primary ? '#fff' : '#1C75BC')};
}
`;